import React from 'react';

const WeekStartsOnOverrideContext = React.createContext<{
  weekStartsOnOverride?: WeekStartsOn;
}>({});

export default WeekStartsOnOverrideContext;
